import React, { useState, useEffect, useRef, forwardRef } from 'react';
import { render, findDOMNode } from 'react-dom';
import { Icon } from 'semantic-ui-react';

export function ScrollToTopButton(props) {
  const intervalId = useRef(0);
  const [scrollStepInPx, setScrollStepInPx] = useState(100); // Interval of offset point jumps for slow scroll
  const [delayInMs, setDelayInMs] = useState(15); // Interval for each scroll (ms)
  const [scrollFastStepInPx, setScrollFastStepInPx] = useState(200); // Interval of offset point jumps for fast scroll

  const scrollStep = (element, isTargetingWindow) => {
    if (isTargetingWindow) {
      if (window.pageYOffset === 0) {
        clearInterval(intervalId.current);
      } else if (window.pageYOffset > 800) {
        // When scroll point is more than 800, will jump to offset = 800 then do the animation on scroll
        window.scroll(0, 800);
      } else if (window.pageYOffset > 400 && window.pageYOffset <= 800) {
        // 400 < offset < 800, will scroll it faster
        window.scroll(0, window.pageYOffset - scrollFastStepInPx);
      } else {
        // offset < 400, will scroll it slower, to give better visual feedback
        window.scroll(0, window.pageYOffset - scrollStepInPx);
      }
    } else {
      if (element.scrollTop === 0) {
        clearInterval(intervalId.current);
      } else if (element.scrollTop > 800) {
        element.scrollTop = 800;
      } else if (element.scrollTop > 400 && element.scrollTop <= 800) {
        element.scrollTop = element.scrollTop - scrollFastStepInPx;
      } else {
        element.scrollTop = element.scrollTop - scrollStepInPx;
      }
    }
  };

  const scrollToTop = () => {
    let targetElementNode = window;
    if (!!props.targetElement) {
      targetElementNode = findDOMNode(props.parentComponentRef.current).parentNode;
      let intervalIdLocal = setInterval(() => {
        scrollStep(targetElementNode, false);
      }, delayInMs);
      intervalId.current = intervalIdLocal;
    } else {
      let intervalIdLocal = setInterval(() => {
        scrollStep(targetElementNode, true);
      }, delayInMs);
      intervalId.current = intervalIdLocal;
    }
  };

  return (
    <button
      title="Back to top"
      className={'scroll-to-top-btn pdlnull pdrnull ' + props.className}
      onClick={scrollToTop}
      style={props.style}
    >
      <Icon className="color-white mrrnull" name="angle up" />
      <div className="color-white text-size-mms" style={{ marginTop: '-3px' }}>
        TOP
      </div>
    </button>
  );
}

export default function ScrollToTopButtonWrapper(props) {
  const scrollToTopWrapper = useRef(null);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    if (!!props.targetElement) {
      let targetElementParentNode = findDOMNode(scrollToTopWrapper.current).parentNode;
      targetElementParentNode.addEventListener('scroll', onScroll);
    } else {
      window.addEventListener('scroll', onScroll);
    }
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  const onScroll = () => {
    if (!!props.targetElement) {
      let targetElementParentNode = findDOMNode(scrollToTopWrapper.current).parentNode;
      if (targetElementParentNode.scrollTop > 100 && !hasScrolled) {
        setHasScrolled(true);
      } else if (targetElementParentNode.scrollTop < 100 && hasScrolled) {
        setHasScrolled(false);
      }
    } else {
      if (window.pageYOffset > 0 && !hasScrolled) {
        setHasScrolled(true);
      } else if (window.pageYOffset == 0 && hasScrolled) {
        setHasScrolled(false);
      }
    }
  };

  return (
    <div ref={scrollToTopWrapper}>
      {hasScrolled ? (
        <ScrollToTopButton
          parentComponentRef={scrollToTopWrapper}
          style={props.style}
          className={props.className}
          targetElement={props.targetElement}
        />
      ) : (
        ''
      )}
    </div>
  );
}
